// extracted by mini-css-extract-plugin
export default {"tileFooter":"TileFooter_tileFooter__e4uE6","tileFooter__content":"TileFooter_tileFooter__content__p93am"};